export const ADD_TOAST = 'toasts/ADD_TOAST'
export const SET_SHOW = 'toasts/SET_SHOW'
